import { MediaType } from "@ui/types/enums/MediaType";

export const HUMAN_READABLE_MEDIA_TYPE: Record<MediaType, string> = {
  [MediaType.AnkiExports]: "anki exports",
  [MediaType.ImageGif]: "gif",
  [MediaType.ImageJpg]: "jpeg",
  [MediaType.ImageJpeg]: "jpeg",
  [MediaType.ImagePng]: "png",
  [MediaType.ModelGltfBinary]: "glb",
  [MediaType.TextCsv]: "csv",
  [MediaType.VideoMp4]: "mp4",
  [MediaType.VideoQuicktime]: "mov",
};
